import {HeaderDetailsDefaultBox} from "./header-details.default.box";

export const HeaderDetailsBox = HeaderDetailsDefaultBox;